/**
 * React Starter Kit for Firebase and GraphQL
 * https://github.com/kriasoft/react-firebase-starter
 * Copyright (c) 2015-present Kriasoft | MIT License
 */

/* @flow */

import createHistory from 'history/createBrowserHistory';

// A wrapper around the HTML 5 History API
// https://github.com/ReactTraining/history
export default createHistory();



// WEBPACK FOOTER //
// ./src/history.js